import { FETCH_ITEM_COPIES, EDIT_ITEM_COPY, DESTROY_ITEM_COPY } from '../actionTypes';

export const fetchItemCopies = copies => ({
    type: FETCH_ITEM_COPIES,
    copies
});

export const editItemCopy = copy => ({
    type: EDIT_ITEM_COPY,
    copy
});

export const destroyItemCopy = key => ({
    type: DESTROY_ITEM_COPY,
    key
})